export const REDIRECT_URL_EXTENSION_ID = '@recative/redirect';
